import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile/pool-types')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('pool-types:list')) {
      throw redirect({ to: '/settings/tenant-profile/general' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/organization/pages/pool-types-page')),
  staticData: { titleKey: 'poolTypes' },
});
